import script from "./consent-page.vue?vue&type=script&setup=true&lang=ts"
export * from "./consent-page.vue?vue&type=script&setup=true&lang=ts"

import "./consent-page.vue?vue&type=style&index=0&id=149602e4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-149602e4"]])

export default __exports__